import { useState as l, useEffect as u } from "react";
const a = (e, s = []) => {
  const [c, r] = l(null), [n, d] = l(null);
  return u(() => {
    if (!e.current) return;
    const t = e.current.closest(
      "[data-scheme]"
    ), o = t && t.dataset.scheme || null;
    c !== o && r(o);
  }, [e, c, ...s]), u(() => {
    if (!e.current) return;
    const t = e.current.closest(
      "[data-mode]"
    );
    if (t === document.documentElement) return;
    const o = t && t.dataset.mode || null;
    n !== o && d(o);
  }, [e, n, ...s]), {
    colorScheme: c,
    colorMode: n
  };
};
export {
  a as u
};
//# sourceMappingURL=scoped-color-scheme.D8FTJTjz.js.map
